import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const CaretDownFill = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='CaretDownFill' {...props}>
    <path d='M18 9H6L12 15L18 9Z' fill='#000' />
  </StyledIcon>
);
